import { useRefreshBookingData } from "../../../hooks/use_refresh_booking_data";
import { GroupBookingsQuestionsOption } from "../../booking_questions/group_bookings_questions.types";
import { BookingFormMode } from "../booking_form.types";
import { BookingFormValues } from "../booking_form_provider";
import { BookingType } from "../booking_type";
import { isGroupOption } from "../workforce_member_select/workforce_member_select.utils";
import { BookingResponse } from "./use_handle_submit";

const getProfileIds = ({ workforceMember }: BookingFormValues) => {
  if (isGroupOption(workforceMember)) {
    return [];
  } else {
    return workforceMember ? [workforceMember.id] : [];
  }
};

type UsePostSubmitActions = {
  mode: BookingFormMode;
  shortlistId: number | undefined;
  bookingGroupId: number | undefined;
};

export const usePostSubmitActions = ({ mode, shortlistId, bookingGroupId }: UsePostSubmitActions) => {
  const refreshBookingData = useRefreshBookingData();

  const postSubmitActions = (bookings: BookingResponse[], values: BookingFormValues) => {
    const { activityId, workforceMember, updateGroupOptionSelected, bookingType } = values;
    const isRepeated = bookingType === BookingType.Repeated;
    const refreshGroup =
      updateGroupOptionSelected === GroupBookingsQuestionsOption.GroupAll ||
      (mode === "create" && isGroupOption(workforceMember));
    const profileIds = getProfileIds(values);
    refreshBookingData({
      bookingIds: bookings.map(({ id }) => id),
      bookingGroupId,
      shortlistId,
      activityId,
      profileIds,
      refreshGroup,
      refreshProfile: isRepeated
    });
  };

  return {
    postSubmitActions
  };
};
